import React from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'

import './CesuPaymentContent.css'

const CesuPaymentContent = ({ t }) =>
  <div>
    <div className="paper-cesu">
      <span className="cesu-title">{t('common:payment:cesu:instruction_for_paper_cesu')}</span>
      <ul className="cesu-list">
        <li><span>{t('common:payment:address:consignee')}</span></li>
        <li><span>{t('common:payment:address:street')}</span></li>
        <li><span>{t('common:payment:address:postal_code_city')}</span></li>
      </ul>
    </div>
    <div className="electronic-cesu">
      <span className="cesu-title">{t('common:payment:cesu:instruction_for_electronic_cesu')}</span>
      <ul className="cesu-list">
        <li><span>{t('common:payment:cesu:code')}</span></li>
        <li><span>{t('common:payment:cesu:beneficiary')}</span></li>
      </ul>
    </div>
  </div>

CesuPaymentContent.propTypes = { t: func }

export default translate()(CesuPaymentContent)



// WEBPACK FOOTER //
// ./src/components/customer/wallet/payments/cesu/CesuPaymentContent.js